import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './index.css';
import App from './App';
import ConnectPage from './pages/ConnectPage';
import AcceptInvitationPage from './pages/AcceptInvitationPage';
import PhotoAlbum from './components/PhotoAlbum';
import PrivateRoute from './components/PrivateRoute';
import Login from './components/Login';
import reportWebVitals from './reportWebVitals';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import PhotoAlbumPage from './components/PhotoAlbumPage';
import SupportPage from './pages/SupportPage';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<App />} />
          <Route path="/login" element={<Login />} />
          <Route path="/connect" element={<ConnectPage />} />
          <Route path="/accept-invitation/:invitationId" element={<AcceptInvitationPage />} />
          <Route 
            path="/photo-album" 
            element={
              <PrivateRoute>
                <PhotoAlbumPage />
              </PrivateRoute>
            } 
          />
          <Route 
            path="/support" 
            element={
              <PrivateRoute>
                <SupportPage />
              </PrivateRoute>
            }
          />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
